var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer",attrs:{"id":"footer"}},[_vm._v("© "+_vm._s(_vm.master.copy))])
}
var staticRenderFns = []

export { render, staticRenderFns }